import _ from "lodash";
import { ProcedureType, OrderType } from "./constants";
import { ItemType } from "./constants";

const procedureLabelMapper = {
  [ProcedureType.IMAGING]: "un estudio",
  [ProcedureType.LABORATORY]: "un analito",
  [OrderType.PRACTICES]: "una práctica",
};

export const getLabel = (searchOptions, procedureType) => {
  const { searchNomenclature, searchTemplates } = searchOptions;
  const procedureLabel = `Seleccioná ${
    procedureLabelMapper[procedureType] ?? "un estudio"
  }`;

  if (searchNomenclature && searchTemplates)
    return `${procedureLabel} o plantilla`;
  if (searchNomenclature) return procedureLabel;
  if (searchTemplates) return "Seleccioná tu plantilla";
};

export const resultsMapper = (item, itemType) => ({
  name: item.name,
  itemType,
});

export const getSeparatedOptions = (options) => {
  const [templates, nomenclatures] = _.partition(
    options,
    (o) => o.itemType === ItemType.TEMPLATE
  );
  return {
    templates,
    nomenclatures,
  };
};

export const getSeparatedOptionsStringified = (options) => {
  const { templates, nomenclatures } = getSeparatedOptions(options);
  return {
    templates: JSON.stringify(templates),
    nomenclatures: JSON.stringify(nomenclatures),
  };
};
